export function getBookmakerDetailsUrl(slug: string): string {
  return `/hub/${slug}`;
}
